window.addEventListener('message', (event) => {
  // Ensure the message comes from Tolstoy
  if (event.data && typeof event.data === 'object') {
    const tolstoyStories = document.querySelector('.tolstoy-stories');
    if (tolstoyStories) {
      const status = tolstoyStories.dataset.status;
      if(status !== 'loaded') {
        return;
      }

      if(window.innerWidth < 1024) {
        const addedVideo = document.querySelector('.pdp-hero__gallery-tolstoy-video');
        if (!addedVideo) {
          const tolstoyStoriesVideo = tolstoyStories.querySelector('video');
          const videoJson = document.querySelector('head script[data-tolstoy-schema="video"][data-tolstoy-video-id]');
          if (tolstoyStoriesVideo && videoJson) {
            let videoJsonData;
            try {
              videoJsonData = JSON.parse(videoJson.textContent);
            } catch (err) {
              videoJsonData = null;
            }

            const videoUrl = videoJsonData && videoJsonData.contentUrl;
            const galleryContainer = document.querySelector('.pdp-hero__images-container');
            if (galleryContainer && videoUrl) {
              const cloneVideo = tolstoyStoriesVideo.cloneNode(true);
              cloneVideo.classList.add('pdp-hero__gallery-tolstoy-video');
              cloneVideo.removeAttribute('data-tolstoy-element');
              cloneVideo.loop = true;
              cloneVideo.muted = true;
              cloneVideo.playsInline = true;
              cloneVideo.setAttribute('tabindex', '0');
              cloneVideo.setAttribute('role', 'button');
              cloneVideo.setAttribute(
                'aria-label',
                'Go to product stories and videos below the gallery'
              );
              cloneVideo.setAttribute('src', videoUrl);
              if (videoJsonData.thumbnailUrl) {
                cloneVideo.setAttribute('poster', videoJsonData.thumbnailUrl);
              }
              
              function scrollToTolstoyStories() {
                tolstoyStories.scrollIntoView({
                  behavior: 'smooth',
                  block: 'start',
                });
              }

              cloneVideo.addEventListener('click', scrollToTolstoyStories);
              cloneVideo.addEventListener('keydown', function (e) {
                if (e.key === 'Enter' || e.key === ' ') {
                  e.preventDefault();
                  scrollToTolstoyStories();
                }
              });
              galleryContainer.appendChild(cloneVideo);
              cloneVideo.play().catch(function () {});
            }
          }
        }
      }

      // Add custom scrollbar
      const tolstoyStoriesContainer = tolstoyStories.querySelector('.tolstoy-stories-container');
      if(!tolstoyStoriesContainer) {
        return;
      }

      const tolstoyCustomScrollbar = tolstoyStoriesContainer.querySelector('.tolstoy-stories-custom-scrollbar');
      if(tolstoyCustomScrollbar) {
        return;
      }

      const customScrollbar = document.createElement('div');
      customScrollbar.classList.add('tolstoy-stories-custom-scrollbar');
      customScrollbar.innerHTML = '<div class="tolstoy-stories-custom-scrollbar-track"></div>';
      tolstoyStoriesContainer.appendChild(customScrollbar);

      const tilesContainer = tolstoyStoriesContainer.querySelector('.tolstoy-stories-tiles-container');
      if (!tilesContainer || tilesContainer.scrollWidth <= 0) {
        return;
      }

      const customScrollbarTrack = customScrollbar.querySelector('.tolstoy-stories-custom-scrollbar-track');
      customScrollbarTrack.style.width = `${tilesContainer.clientWidth * 100 / tilesContainer.scrollWidth}%`;

      tilesContainer.addEventListener('scroll', () => {
        customScrollbarTrack.style.width = `${(tilesContainer.scrollLeft + tilesContainer.clientWidth) * 100 / tilesContainer.scrollWidth}%`;
      });
    }
  }
});
